import { motion } from "framer-motion";
import { IMAGES } from "../data/site";

const line = {
  hidden: { y: "110%" },
  visible: (i) => ({
    y: "0%",
    transition: { duration: 1, delay: 0.4 + i * 0.14, ease: [0.22, 1, 0.36, 1] },
  }),
};

const HEADLINE = ["The art", "of deep", "sleep."];

export const Hero = () => {
  return (
    <section id="top" data-testid="hero-section" className="relative min-h-screen w-full overflow-hidden">
      {/* Background image — right 2/3, parallax-ish */}
      <motion.div
        initial={{ scale: 1.12 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
        className="absolute top-0 right-0 h-full w-full md:w-[64%]"
      >
        <img
          src={IMAGES.hero}
          alt="Premium minimalist bedroom"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#FFFFFF] via-[#FFFFFF]/20 to-transparent md:from-[#FFFFFF] md:via-transparent" />
      </motion.div>

      {/* Content anchored bottom-left */}
      <div className="relative z-10 max-w-[1600px] mx-auto px-4 md:px-8 min-h-screen flex flex-col justify-end pb-16 md:pb-24">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="overline mb-6"
          data-testid="hero-overline"
        >
          Foam & Mattress Manufacturer · Rohini, Delhi
        </motion.p>

        <h1 className="font-heading font-light text-foreground leading-[0.92] tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-[9rem]">
          {HEADLINE.map((l, i) => (
            <span key={i} className="reveal-mask">
              <motion.span
                custom={i}
                variants={line}
                initial="hidden"
                animate="visible"
                className="block italic first:not-italic"
                style={i === 2 ? { fontStyle: "italic", color: "#7BA7CC" } : {}}
              >
                {l}
              </motion.span>
            </span>
          ))}
        </h1>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.2, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="mt-10 flex flex-col sm:flex-row sm:items-end gap-8 max-w-3xl"
        >
          <p className="text-base md:text-lg leading-relaxed text-foreground/70 max-w-md">
            Handcrafted foam mattresses, orthopedic cores and custom seating —
            engineered in Rohini for a decade of restful nights.
          </p>
          <a
            href="#collection"
            data-testid="hero-cta"
            className="shrink-0 inline-flex items-center gap-3 px-7 py-4 rounded-full bg-foreground text-primary-foreground text-sm tracking-wide hover:bg-accent hover:text-foreground transition-colors duration-300"
          >
            Explore the collection
            <span aria-hidden>→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
